import { signal } from "@angular/core";

export interface MenuItem {
    title: string;
    link: string;
    globalcontentid: string;
    inputdata: any;
    list: MenuItem[];
    isitem: boolean;
    active: boolean;
}

export class Menu {
    currentMenuName: string = '';
    currentMenuName2: string = '';
    menu: MenuItem;
    menu2: any;
    menuHistory: MenuItem[] = [];
    menuHistory2: any[] = [];
    isDefault2 = signal<boolean>(false);

    setMenus(menu: MenuItem): void {
        this.menu = menu;
        this.setCurrentMenu(menu);
    }

    setMenus2(menu: any): void {
        this.menu2 = menu;
        // this.setCurrentMenu2(menu);
    }

    setCurrentMenu(menu: MenuItem): void {
        this.menuHistory.push(menu);
        this.currentMenuName = menu?.title;
    }

    setCurrentMenu2(menu: any): void {
        // menu?.menus?.sort((a, b) => String(a.title).localeCompare(String(b.title)));
        this.menuHistory2.push(menu);
        this.currentMenuName2 = menu.title;
    }

    goBack(): void {
        if (this.menuHistory?.length > 0) {
            this.menuHistory.pop();
            this.currentMenuName = this.menuHistory[this.menuHistory.length - 1].title;
        }
    }

    goBack2(): void {
        if (this.menuHistory2?.length > 0) {
            this.menuHistory2.pop();
            this.currentMenuName2 = this.menuHistory2[this.menuHistory2.length - 1].title;
        }
    }

    resetHistory(): void {
        this.menuHistory = [this.menu];
        this.currentMenuName = this.menu.title;
    }

    resetHistory2(): void {
        this.menuHistory2 = [this.menu2];
        this.currentMenuName2 = this.menu2.title;
    }
}
